module.exports = __webpack_public_path__ + "static/media/jardines02M.3aa542a0.jpg";